
<div *ngIf="homeDevices == null" class="device-loader">
  <div class="loader-body sp-middle-element">
    <div class="col-sm-12">
      <div class="loader center-block"></div>
    </div>
  </div>
</div>

<div *ngIf="homeDevices != null && (viewType == null || viewType == 'List')">
  <ng-container *ngIf="homeDevices.length < 1">
    <div class="row">
      <div class="col-lg-10 col-lg-offset-1 col-sm-12">
        <div class="shared-div">
          <div class="row">
            <div class="col-sm-12">
              <p>{{ ('LOCKS.NO_LOCKS' | translate).replace("{home}", this.homeName) }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="homeLocks.length > 0 && !accessibleLocks && !accessNotStarted">
    <div class="col-lg-10 col-lg-offset-1 col-sm-12">
      <div class="row sp-middle-element without-warning">
        <div class="thumbnail sp-lock-value homealign">
          <div class="col-md-1 col-sm-1 pull-left">
            <img class="lock-list lock" style="width: 60px !important;" src="../../../../assets/images/accessExpired.png" alt="Access Expired" />
          </div>
          <div class="col-md-5 col-sm-6">
            <div class="sp-lock-name col-xs-8">
              <div class="row">{{ 'LOCKS.ACCESS_EXPIRED.TITLE' | translate }}</div>
              <div class="row">
                <div class="sp-lock-type pull-left">
                  <span class="sp-lock-State">{{ 'LOCKS.ACCESS_EXPIRED.MSG' | translate }}</span>
                </div>
              </div></div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="homeDevices.length > 0 && accessibleLocks && !windowAccess || accessNotStarted">
    <div class="col-lg-10 col-lg-offset-1 col-sm-12">
      <div class="row sp-middle-element without-warning">
        <div class="thumbnail sp-lock-value homealign">
          <div class="col-md-1 col-sm-1 pull-left">
            <img class="lock-list lock" style="width: 60px !important;" src="../../../../assets/images/invalidAccessWindow.png" alt="Access Expired" />
          </div>
          <div class="col-md-5 col-sm-6">
            <div class="sp-lock-name">
              <div class="row">{{ 'LOCKS.INVALID_WINDOW.TITLE' | translate }}</div>
              <div class="row">
                <div class="sp-lock-type pull-left">
                  <span class="sp-lock-State" *ngIf="home.accessTime.accesstimetype === 'WEEKLY'">
                    {{ 'LOCKS.INVALID_WINDOW.LABEL' | translate }}
                    {{ (+home.accessTime.starttime * 1000) | date: 'h:mm a' }}
                    –
                    {{ (+home.accessTime.endtime * 1000) | date: 'h:mm a' }}
                  <ng-container>
                    <span class="day-list">
                      <ng-container *ngFor="let dayLabel of getTranslatedDays(home.accessTime.days); let isLast = last">
                     {{ dayLabel }}<span *ngIf="!isLast">, </span>
                      </ng-container>
                    </span>
                  </ng-container>
                </span>
                <span class="sp-lock-State" *ngIf="home.accessTime.accesstimetype === 'DATE_RANGE'">
                    {{ 'LOCKS.ACCESS_NOT_STARTED.MSG' | translate }}
                    <ng-container *ngIf="home?.accessTime?.accesstimetype === 'DATE_RANGE'">
                      {{ (+home.accessTime.startdate * 1000) | date: 'medium' }}
                    </ng-container>
                </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <div class="col-lg-10 col-lg-offset-1 col-sm-12" *ngIf="homeDevices.length > 0 && accessibleLocks && windowAccess && !accessNotStarted">
    <div *ngFor="let device of homeDevices">
      <div *ngIf="checkDeviceType(device) === 'lock'">
        <div class="row sp-middle-element" [ngClass]="{'without-warning' : ((device.lockBattery <= batteryLevel && this.checkUpdateLastStatus(device.lastUpdateStatus))
          || (device.lockState && device.lockState === this.lockState && this.checkUpdateLastStatus(device.lastUpdateStatus)))
          || (device.bleAdvertisement && device.bleAdvertisement === bleAdvertisement) || !checkUpdateLastStatus(device.lastUpdateStatus)}">
          <app-lock-card [lock]='device' [member]='member' [viewType]='viewType'></app-lock-card>
        </div>
      </div>
      <div *ngIf="checkDeviceType(device) === 'gdo'">
        <div class="row sp-middle-element" [ngClass]="{'without-warning': true}">
          <app-gdo-card [gdo]='device' [member]='member' [viewType]='viewType'></app-gdo-card>
        </div>
      </div>
    </div>
  </div>

</div>

<div *ngIf="homeDevices != null && viewType != null && viewType == 'Grid'">
  <ng-container *ngIf="homeDevices.length <= 0">
    <div class="row">
      <div class="col-lg-10 col-lg-offset-1 col-sm-12">
        <div class="shared-div">
          <div class="row">
            <div class="col-sm-12">
              <p>{{ ('LOCKS.NO_LOCKS' | translate).replace("{home}",this.homeName)}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="homeLocks.length > 0 && !accessibleLocks && !accessNotStarted">
    <div class="row">
      <div class="col-lg-10 col-lg-offset-1 col-sm-12 text-center">
        <div class="shared-div">
          <img class="center-block lock" src="../../../../assets/images/accessExpired.png" alt="Access Expired" />
          <h4>{{ 'LOCKS.ACCESS_EXPIRED.TITLE' | translate }}</h4>
          <p>{{ 'LOCKS.ACCESS_EXPIRED.MSG' | translate }}</p>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="homeLocks.length > 0 && accessibleLocks && !windowAccess || accessNotStarted">
    <div class="row">
      <div class="col-lg-10 col-lg-offset-1 col-sm-12 text-center">
        <div class="shared-div">
          <img class="center-block lock" src="../../../../assets/images/invalidAccessWindow.png" alt="Access Expired" />
          <h4>{{ 'LOCKS.INVALID_WINDOW.TITLE' | translate }}</h4>
          <div class="access-time-text">
            <span *ngIf="home.accessTime.accesstimetype === 'WEEKLY'" class="time-range">{{ 'LOCKS.INVALID_WINDOW.LABEL' | translate }}
              {{ (+home.accessTime.starttime * 1000) | date: 'h:mm a' }}
              –
              {{ (+home.accessTime.endtime * 1000) | date: 'h:mm a' }}
            </span>
            <span *ngIf="home.accessTime.accesstimetype === 'DATE_RANGE'" class="time-range">{{ 'LOCKS.ACCESS_NOT_STARTED.MSG' | translate }}
              {{ (+home.accessTime.startdate * 1000) | date: 'medium' }}
            </span>
        <ng-container *ngIf="home.accessTime.accesstimetype === 'WEEKLY'">
          <span class="day-list">
            <ng-container *ngFor="let dayLabel of getTranslatedDays(home.accessTime.days); let isLast = last">
            {{ dayLabel }}<span *ngIf="!isLast">, </span>
            </ng-container>
          </span>
        </ng-container>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <div class="col-lg-10 col-lg-offset-1 col-sm-12 no-padding" *ngIf="homeDevices.length > 0 && accessibleLocks && windowAccess && !accessNotStarted">
    <div class="row sp-home-grid-row">
      <div class="col-xs-12 col-sm-6 col-md-4" *ngFor="let device of homeDevices">
        <div *ngIf="checkDeviceType(device) === 'lock'">
          <app-lock-card [lock]='device' [member]='member' [viewType]='viewType'></app-lock-card>
        </div>
        <div *ngIf="checkDeviceType(device) === 'gdo'">
          <app-gdo-card [gdo]='device' [member]='member' [viewType]='viewType'></app-gdo-card>
        </div>
      </div>
    </div>
  </div>
</div>
